import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix default icon issues with webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});

const MapView = ({ latitude, longitude }) => {
  const position = [latitude, longitude];

  // Add custom CSS to control Leaflet z-index
  useEffect(() => {
    // Add custom style to control leaflet z-index
    const style = document.createElement('style');
    style.innerHTML = `
      .leaflet-map-pane, 
      .leaflet-tile,
      .leaflet-marker-icon, 
      .leaflet-marker-shadow, 
      .leaflet-tile-pane, 
      .leaflet-overlay-pane, 
      .leaflet-shadow-pane,
      .leaflet-marker-pane, 
      .leaflet-popup-pane, 
      .leaflet-overlay-pane svg, 
      .leaflet-zoom-box, 
      .leaflet-image-layer, 
      .leaflet-layer {
        z-index: 1 !important;
      }
      .leaflet-popup {
        z-index: 2 !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <MapContainer
      center={position}
      zoom={18}
      className="h-48 w-full rounded-lg shadow-lg"
      zoomControl={false}
      dragging={false}
      attributionControl={false}  
      scrollWheelZoom={false}
      doubleClickZoom={false}
      touchZoom={false}
      style={{ zIndex: 1 }}
    >
      <TileLayer
        // attribution='&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position}>
        <Popup className="text-sm">
          You are here.
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapView;
